module.exports = __webpack_public_path__ + "static/media/48411183_2109083065983310_1679534106263683072_n_edited.1cdbce9c.jpg";